// Shared legend config for the spectral overlay layers (NDVI / soil brightness /
// soil moisture). The gradients mirror the color ramps in the backend evalscripts
// (sentinelHubService.ts) so the on-map overlay and the legend agree.

export type SpectralLayer = "ndvi" | "brightness" | "moisture";

export type SpectralLegendConfig = {
  title: string;
  gradient: string; // CSS gradient stops (left → right)
  labels: string[]; // rendered space-between under the bar
};

export function spectralLegend(layer: SpectralLayer, lang: any): SpectralLegendConfig {
  const f = lang?.fields ?? {};
  switch (layer) {
    case "brightness":
      return {
        title: f.mapSelecterBrightness ?? "Soil brightness",
        gradient: "#5a3c28, #966e46, #c8a573, #e6d2aa, #f5f0e1",
        labels: [f.legendDarker ?? "Darker", f.legendBrighter ?? "Brighter"],
      };
    case "moisture":
      return {
        title: f.mapSelecterMoisture ?? "Soil moisture",
        gradient: "#d6bc8c, #c8c896, #82c8c8, #3c96d2, #1450be",
        labels: [f.legendDrier ?? "Drier", f.legendWetter ?? "Wetter"],
      };
    case "ndvi":
    default:
      return {
        title: f.mapSelecterNdvi ?? "NDVI",
        gradient: "#8c6440, #c87840, #f0c850, #b4dc50, #64be3c, #32a028, #147814",
        labels: ["-0.2", "0.5", "0.9"],
      };
  }
}
